import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { INode } from 'common/builder/nodes/nodeInterfaces'

import {
  ActionGroupCustomEventsNodeGenericPreloaderRule,
  ActionGroupRequiredNodeGenericPreloaderRule,
  CommonRequiredDataNodeGenericPreloaderRule,
  CommonUserFieldsNodeGenericPreloadRule,
  ConditionGenericNodePreloadRule,
} from './preloaderRules'

export const GenericNodePreloaderRules: Array<PreloaderRule<INode, NodePreloadRulePayload>> = [
  CommonRequiredDataNodeGenericPreloaderRule,
  CommonUserFieldsNodeGenericPreloadRule,
  ActionGroupRequiredNodeGenericPreloaderRule,
  ActionGroupCustomEventsNodeGenericPreloaderRule,
  ConditionGenericNodePreloadRule,
]
